import { IResponseState } from '../../../components/Modals/ResponseModal/module/constants'
import { IEntitlementItem } from '../../../models/CreateCertification'
import {
  IAddedApplicationItem,
  IAddedTechnicalUserItem,
  IAddedUsersItem,
  IConfigurationItem,
  IEditCertificationCampaign,
  IEditCertificationReferenceObject,
} from '../../../models/Recertification'
import { ROUTES } from '../../../module/constants'
import { generalConst } from '../../../module/globalInterface'

export interface ICertificationReferenceProps {
  changeLocation: (url: string) => {}
  certificationReferenceSetTriggerConfirmModal: (payload: any) => void
  callState: IResponseState
  confirmModalTrigger: boolean
  requestEditCertification: IEditCertificationCampaign
  editCampaign: (payload: IEditCertificationReferenceObject) => {}
  addedApplications: IAddedApplicationItem[]
  addedBrs: any[]
  addedUsers: IAddedUsersItem[]
  addedEntitlements: IEditPerimeterEntitlementItem[]
  addedGroups: IEditPerimeterGroupItem[]
  addedTechnicalUsers: IAddedTechnicalUserItem[]
  campaignConfig: IConfigurationItem
}

export const CERTIFICATION_REFERENCE_URL: generalConst = {
  BASE_URL: ROUTES.CERTIFICATION_REFERENCE,
  STEP_ONE: ROUTES.CERTIFICATION_REFERENCE,
  STEP_TWO: `${ROUTES.CERTIFICATION_REFERENCE}/step-two`,
  STEP_THREE: `${ROUTES.CERTIFICATION_REFERENCE}/step-three`,
  STEP_FOUR: `${ROUTES.CERTIFICATION_REFERENCE}/step-four`,

  EDIT_DETAIL: `${ROUTES.CERTIFICATION_REFERENCE}/edit-detail`,
  EDIT_NOTE: `${ROUTES.CERTIFICATION_REFERENCE}/edit-note`,
  EDIT_REVISOR: `${ROUTES.CERTIFICATION_REFERENCE}/edit-revisor`,
  EDIT_SUPERVISORS: `${ROUTES.CERTIFICATION_REFERENCE}/edit-supervisors`,

  EDIT_PERIMETER_GROUPS: `${ROUTES.CERTIFICATION_REFERENCE}/edit-perimeter-groups`, // step five
  EDIT_PERIMETER_USERS: `${ROUTES.CERTIFICATION_REFERENCE}/edit-perimeter-users`, // step six
  EDIT_PERIMETER_APPLICATIONS: `${ROUTES.CERTIFICATION_REFERENCE}/edit-perimeter-applications`, // step seven
  EDIT_PERIMETER_BRS: `${ROUTES.CERTIFICATION_REFERENCE}/edit-perimeter-brs`, // step eight
  EDIT_PERIMETER_OWNERSHIP: `${ROUTES.CERTIFICATION_REFERENCE}/edit-perimeter-ownership`, // step nine
  EDIT_PERIMETER_TECHNICAL_USERS: `${ROUTES.CERTIFICATION_REFERENCE}/edit-perimeter-technical-users`, // step ten
}

export const GROUP_IDENTIFIER = 'OU'
export const OWNERSHIP_IDENTIFIER = 'ENTITLEMENT'
export const APPLICATION_IDENTIFIER = 'APPLICATION'
export const BUSINESS_ROLE_IDENTIFIER = 'BUSINESS_ROLE'
export const USER_IDENTIFIER = 'USER'
export const TECHNICAL_USER_IDENTIFIER = 'TECHNICAL_USER'
export const ROBOT_USER_IDENTIFIER = 'Robot'
export const SERVICE_USER_IDENTIFIER = 'SERVICE'

export const CertificationTypeString = {
  USER: 'USER',
  ENTITLEMENT: 'ENTITLEMENT',
  BUSINESS_ROLE: 'BUSINESS_ROLE',
  OU: 'OU',
  ACCOUNT: 'ACCOUNT',
  TECHNICAL_USER: 'TECHNICAL_USER',
  Robot: 'Robot',
  Service: 'Service',
}

export const CERTIFICATION_REFERENCE_IDENTIFIER: generalConst = {
  IMPERSONIFICATION: 'impersonification',
  ITEM_DETAIL: 'itemDetail',
  STEP_ONE: 'stepOne',
  RAW_LIST: 'rawList',
  STEP_TWO: 'stepTwo',
  CAMPAIGN_REVISORS: 'campaignRevisors',
  CAMPAIGN_REVISORS_LOADER: 'campaignRevisorsLoader',
  STEP_THREE: 'stepThree',
  ACCESS_ROLE: 'accessRole',
  SELECTED_CERTIFICATION: 'selectedCertification',
  CAMPAIGN_CONFIG: 'campaignConfig',
  CONFIRM_EXECUTION: 'confirmExecution',
  CALL_STATE: 'callState',
  REVISORS: 'revisors',
  CURRENT_USER: 'currentUser',
  IS_ADMIN: 'isAdmin',
  IS_SUPERVISOR: 'isSupervisor',
  ADDED_GROUPS: 'addedGroups',
  EDIT_PERIMETER_GROUPS: 'editPerimeterGroups',
  EDIT_PERIMETER_OWNERSHIP: 'editPerimeterOwnership',
  EDIT_PERIMETER_TECHNICAL_USERS: 'editPerimeterTechnicalUsers',
  ADDED_TECHNICAL_USERS: 'addedTechnicalUsers',
  TECHNICAL_USERS: 'technicalUsers',
  TAB_SELECTED_IDENTIFIER: 'tabSelected',
  GROUPS: 'groups',
  SUPERVISORS: 'supervisors',
  ADDED_SUPERVISORS: 'addedSupervisors',
  ENTITLEMENTS: 'entitlements',
  ADDED_ENTITLEMENTS: 'addedEntitlements',
  CONFIRM_MODAL_TRIGGER: 'confirmModalTrigger',
  EDIT_PERIMETER_USERS: 'editPerimeterUsers',
  USERS: 'users',
  ADDED_USERS: 'addedUsers',
  EDIT_PERIMETER_BRS: 'editPerimeterBRs',
  BR: 'br',
  ADDED_BR: 'addedBr',
  EDIT_PERIMETER_APPLICATIONS: 'editPerimeterApplications',
  APPLICATIONS: 'applications',
  ADDED_APPLICATIONS: 'addedApplication',
  TABS_IDENTIFIER: 'tabs',
  USER_LIST_IDENTIFIER: 'userList',
  OU_LIST_IDENTIFIER: 'ouList',
  BR_LIST_IDENTIFIER: 'brList',
  ENTITLEMENT_LIST_IDENTIFIER: 'entitlementList',
  ACCOUNT_LIST_IDENTIFIER: 'accountList',
  APPLICATION_LIST_IDENTIFIER: 'applicationList',
  TECHNICAL_USER_LIST_IDENTIFIER: 'technicalUserList',
  ITEM_LIST_IDENTIFIER: 'itemList',
  EDIT_REVISOR: 'editRevisor',
  ITEM_IDENTIFIER: 'item',
  AGGREGATE_OU_ITEMS: 'aggregateOuItems',
  AGGREGATE_BR_ITEMS: 'aggregateBusinessRoleItems',
  AGGREGATE_USER_ITEMS: 'aggregateUserItems',
  AGGREGATE_ENTITLEMENTS_ITEMS: 'aggregateEntitlementsItems',
  AGGREGATE_TECHNICAL_USERS_ITEMS: 'technicalUsersItems',
}

// export const REVISOR_LIST_IDENTIFIER: string = "revisorsList";
export const LIST_IDENTIFIER: string = 'list'
export const LOADER_IDENTIFIER: string = 'loader'
export const SELECTED_ITEM: string = 'selectedItem'

export enum CertificationOperationType {
  KEEP = 'KEEP',
  REVOKE = 'REVOKE',
  VALIDATE = 'VALIDATE',
}

export interface IEditPerimeterEntitlementItem extends IEntitlementItem {
  include: boolean
}
export interface IEditPerimeterGroupItem {
  id: string
  name: string
  ownercode: string
  identitySystemId: string
  include: boolean
}

export interface IFetchMassiveEntitlementItem {
  entitlementId: string
  identitySystemId: string
  isBusinessRole: string
}
export interface IFetchMassiveBody {
  items: IFetchMassiveEntitlementItem[] | string[]
  note: string
}
